import { LogOut, ChevronRight } from 'lucide-react';
import { Button } from '@leadsnavi/ui-kit';
import PawwordIcon from '@/assets/icons/password.svg?react';
import useUserStore from '@/stores/userStore';
import useLogout from '@/hooks/useLogout';
import ChangePassword from '../components/change-password';

export default function Account() {
  const { user } = useUserStore();
  const { handleLogoutWithConfirm } = useLogout();

  return (
    <div className="px-5 py-4">
      <div className="flex items-center gap-10 py-3 min-w-0">
        <div className="min-w-0 flex-1">
          <div className="text-xs text-[#737373]">Email</div>
          <div className="text-sm font-medium truncate max-w-full text-[#262626]">{user?.email || ''}</div>
        </div>

        <Button variant="outline" size="sm" className="h-8 w-8" onClick={() => handleLogoutWithConfirm(true)}>
          <LogOut size={16} color="#525252" />
        </Button>
      </div>

      {user?.signUpType === 'EMAIL' && (
        <ChangePassword>
          <div className="bg-[#F5F5F5] rounded-[8px] select-none p-3 mt-4 flex items-center justify-between cursor-pointer text-[#262626]">
            <span>Password</span>
            <div className="flex items-center gap-2">
              <PawwordIcon />
              <ChevronRight size={14} className="block" />
            </div>
          </div>
        </ChangePassword>
      )}
    </div>
  );
}
